import { render, staticRenderFns } from "./AddUtterance.vue?vue&type=template&id=405d6a3e&scoped=true&"
import script from "./AddUtterance.vue?vue&type=script&lang=js&"
export * from "./AddUtterance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405d6a3e",
  null
  
)

export default component.exports